<script>
  import In from "@/components/atoms/In";
  import Btn from "@/components/atoms/Btn";
  import Banner from "@/components/atoms/Banner";
  import SaveFile from "@/components/atoms/SaveFile";
  import Loading from "@/components/atoms/Loading";
  import Drawer from "@/components/atoms/Drawer";
  import CardsLoadingSpinner from "@/components/atoms/CardsLoadingSpinner";
  export default {
    components: { In, Btn, Banner, SaveFile, Loading, Drawer, CardsLoadingSpinner },
    created(){
      this.$store.dispatch("saveFiles/loadPublicSaveFiles", null, {root: true});
    },
    data(){
      return {
        active_application: null,
        search: ""
      }
    },
    computed: {
      publicSaveFiles(){
        // console.log(this.$store.get('saveFiles/saveFiles').length)
        return this.$store.get('saveFiles/publicSaveFiles')
      },
      filteredSaveFiles(){
        return this.publicSaveFiles.filter(saveFile => (
          this.active_application ? saveFile.applications.includes(this.active_application) : true
        )).filter(saveFile => {
          const search = this.search.toLowerCase();
          const id = saveFile.id ? saveFile.id.toLowerCase() : "";
          const name = saveFile.name ? saveFile.name.toLowerCase() : "";
          const description = saveFile.description ? saveFile.description.toLowerCase() : "";
          return id.includes(search) || name.includes(search) || description.includes(search)
        })
      },
      applications(){
        const a = this.publicSaveFiles.reduce((acc, file) => {
          return {
            ...acc,
            ...(
              file.applications ? 
              file.applications.reduce((bcc, category) => ({...bcc, [category]: category}), {}) : 
              {}
            )
          }
        }, {})
        // console.log(a);
        return a;
      }
    }
  }
</script>

<template>
  <Banner :fixed-height="true">
    <div id="template-page">
      <Loading :loading="$store.get('saveFiles/loading')"/>
      <Drawer>
        <template v-slot:drawer> 
          <div class="parts-drawer">
            
            <div class="search-area">
              <in v-model="search" class="input" icon="fa-search"></in>
            </div>
            <div class="bread-crumbs" v-if="false">
              <span class="link active">
                All Templates
              </span>
            </div>
            <div class="filters">
              <div class="filter low">
                <div class="filter-title">
                  Application
                </div>
                <div class="filter-links">
                  <div v-for="(categoryId, index) in Object.keys(applications)" :key="index" :class="{'active': active_application == categoryId}" class="link" @click="() => { active_application == categoryId ? active_application = null : active_application = categoryId }">
                    {{categoryId}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:page>
          <div class="save-module">
            <div class="save-title">
              Templates
            </div>
            <CardsLoadingSpinner v-if="$store.get('saveFiles/publicSaveFilesLoading')"/>
            <div class="save-file-container">
              <SaveFile v-for="saveFile in filteredSaveFiles" :key="saveFile.id" :save-file="saveFile" :show-options="$store.get('vr')" @load="$store.dispatch('saveFiles/loadFromCloud', saveFile)" @click="$router.push('/template/'+saveFile.id)"/>
            </div>
          </div>
        </template>
      </Drawer>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
#template-page{
  // display: flex;
  // align-items: center;
  // justify-content: center;
  height: 100%;
  .save-module{
    padding-bottom: 6rem;
    max-width: 110rem;
    .save-title{
      font-size: 2.5rem;
      margin: 2rem 2rem 0rem 2rem;
    }
    .save-file-container{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .parts-drawer{
    padding: 0rem 0rem 2rem 0rem;
    .bread-crumbs{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 1rem 1rem 0rem 1rem;
      font-size: 1.25rem;
      .divider{
        color: #AAA;
      }
      .link{
        margin: 0rem 0.5rem;
        padding: 0.5rem 0.5rem;
        color: #FFF;
        
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.active{
          color: #AAA;
        }
        &:not(.active){
          &:hover, &.hover{
            background-color: $black_4;
            cursor: pointer;
            border-radius: 0.5rem;
          }
        }
        * {
          pointer-events: none;
        }
      }
    }
    .search-area{
      padding: 1.5rem 1.5rem 2rem 1.5rem;
    }
    .filters{
      padding-bottom: 0.5rem;
      .filters-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2rem 2rem 0rem 2rem;
        font-size: 1.5rem;
        height: 4rem;
        .filter-count{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          font-weight: 400;
          border-radius: 0.5rem;
          border: 1px solid #FFF;
          padding: 0.5rem 1rem;
          &:hover, &.hover{
            background-color: $black_4;
            cursor: pointer;
          }
          * {
            pointer-events: none;
          }
          .fal{
            margin-right: 0.5rem;
          }
        }
      }
      .toggle{
        // margin: 0.5rem 0rem 0rem 0rem;
      }
      .filter{
        padding: 0rem 0.5rem 1rem 0.5rem;
        &.low{
          // padding: 0.5rem 1rem 0rem 1.5rem;
        }
        .filter-title{
          font-size: 1.25rem;
          padding: 0rem 1rem 0.125rem 1rem;
          color: $w_1;
        }
        .filter-links{
          padding-top: 0.5rem;
          padding-left: 1rem;
          padding-right: 1rem;
          .link{
            font-size: 1.25rem;
            color: #FFF;
            padding: 0.75rem 1rem;
            border-radius: 0.25rem;
            display: flex;
            align-items: center;
            &:hover, &.hover{
              background-color: $black_4;
              cursor: pointer;
            }
            &.active{
              background-color: $p;
            }
          }
        }
        .filter-button-group{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .filter-button{
            font-size: 1.25rem;
            color: #FFF;
            padding: 1rem 1.5rem;
            margin: 0.125rem;
            border-radius: 0.25rem;
            &:hover, &.hover{
              background-color: $black_4;
            }
            * {
              pointer-events: none;
            }
            &.active{
              background-color: $p;
            }
            &.small{
              padding: 0.5rem 1rem;
            }
          }
        }
        .filter-icon-group{
          .filter-icon{
            color: #FFF;
            padding: 1rem 2rem;
            border-radius: 0.25rem;
            display: flex;
            align-items: center;
            &:hover, &.hover{
              background-color: $black_4;
            }
            * {
              pointer-events: none;
            }
            &.active{
              background-color: $p;
            }
            .icon-label{
              font-size: 1.25rem;
              padding: 0rem 1.5rem;
            }
          }
        }
      }
    }
  }
}
</style>